/* Dependencies
 ---------------------------------------------------------- */
import { Application } from 'wrapper6'

/* Register services
 ---------------------------------------------------------- */

/* Modules
 ---------------------------------------------------------- */
import Navigation from 'modules/_navigation'
import ObjectFit from 'modules/_object-fit'
import Print from 'modules/_print'
import Lexicon from './modules/_lexicon'
import SingleLexicon from './modules/_single-lexicon'
import LexiconSlider from './modules/_lexicon-slider'
import Tasks from './modules/_tasks'
import PostSlider from './modules/_post-slider'
import LexiconTooltip from './modules/_lexicon-tooltip'
import PostLoop from './modules/_post-loop'
import TasksMenu from './modules/_tasks-menu'

/* Vendor
 ---------------------------------------------------------- */

/* Setup
 ---------------------------------------------------------- */
const app = window.app = new Application(window.options || {});

/* Services
 ---------------------------------------------------------- */

(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('remove')) {
      return
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove () {
        this.parentNode.removeChild(this)
      }
    })
  })
})([Element.prototype, CharacterData.prototype, DocumentType.prototype])

/* Register modules
 ---------------------------------------------------------- */

app.use(Navigation)
app.use(ObjectFit)
app.use(Print)
app.use(Lexicon)
app.use(SingleLexicon)
app.use(LexiconSlider)
app.use(Tasks)
app.use(PostSlider)
app.use(LexiconTooltip)
app.use(PostLoop)
app.use(TasksMenu)

require('./app')
